export default __webpack_public_path__ + "images/d66ceed19b69ba42dbe979dd7bf096be.svg";